import { FormEvent, useState } from 'react';
import { api } from '../api';
import { useAuth } from '../auth';

export function SettingsPage() {
  const { user, refresh } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<{ kind: 'ok' | 'err'; text: string } | null>(null);
  const [tgLinking, setTgLinking] = useState(false);
  const [tgLink, setTgLink] = useState<string | null>(null);
  const [tgError, setTgError] = useState<string | null>(null);
  const [tgUnlinkConfirm, setTgUnlinkConfirm] = useState(false);
  const [tgUnlinking, setTgUnlinking] = useState(false);

  const telegramLinked = Boolean(user?.telegramId);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setMessage(null);
    setSubmitting(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      setMessage({ kind: 'ok', text: 'Пароль обновлён. Другие сессии завершены.' });
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      setMessage({ kind: 'err', text: err instanceof Error ? err.message : 'Ошибка' });
    } finally {
      setSubmitting(false);
    }
  }

  async function onConnectTelegram() {
    setTgError(null);
    setTgLinking(true);
    try {
      const res = await api.requestTelegramLink();
      setTgLink(res.deepLink);
      window.open(res.deepLink, '_blank', 'noopener');
    } catch (err) {
      setTgError(err instanceof Error ? err.message : 'Не удалось создать ссылку');
    } finally {
      setTgLinking(false);
    }
  }

  async function onUnlinkTelegram() {
    setTgError(null);
    setTgUnlinking(true);
    try {
      await api.unlinkTelegram();
      setTgUnlinkConfirm(false);
      setTgLink(null);
      await refresh();
    } catch (err) {
      setTgError(err instanceof Error ? err.message : 'Не удалось отвязать Telegram');
    } finally {
      setTgUnlinking(false);
    }
  }

  return (
    <div className="container">
      <h1>Настройки</h1>
      <div className="card">
        <h2>Аккаунт</h2>
        <div className="row"><span>Email</span><span>{user?.email ?? '—'}</span></div>
        <div className="row">
          <span>Telegram</span>
          <span>{user?.telegramUsername ? `@${user.telegramUsername}` : user?.telegramId ? `id ${user.telegramId}` : 'не привязан'}</span>
        </div>
        {!telegramLinked && (
          <div style={{ marginTop: 12 }}>
            <p className="muted" style={{ marginTop: 0 }}>
              Привяжите Telegram, чтобы управлять подпиской и получать уведомления в боте.
            </p>
            <button type="button" className="secondary" disabled={tgLinking} onClick={onConnectTelegram}>
              {tgLinking ? 'Готовим ссылку…' : 'Подключить Telegram'}
            </button>
            {tgLink && (
              <p className="muted" style={{ marginTop: 10 }}>
                Если бот не открылся автоматически, перейдите по{' '}
                <a href={tgLink} target="_blank" rel="noopener">этой ссылке</a> и нажмите «Запустить» в боте.
                После привязки обновите страницу.
              </p>
            )}
            {tgError && <div className="error" style={{ marginTop: 10 }}>{tgError}</div>}
          </div>
        )}
        {telegramLinked && (
          <div style={{ marginTop: 12 }}>
            <p className="muted" style={{ marginTop: 0 }}>
              Telegram привязан. Можно отвязать — подписка и доступ сохранятся, но уведомления в боте
              и управление через бот перестанут работать.
            </p>
            {!tgUnlinkConfirm ? (
              <button type="button" className="secondary" disabled={tgUnlinking} onClick={() => { setTgError(null); setTgUnlinkConfirm(true); }}>
                Отвязать Telegram
              </button>
            ) : (
              <div className="row" style={{ gap: 10, flexWrap: 'wrap' }}>
                <button type="button" disabled={tgUnlinking} onClick={onUnlinkTelegram}>
                  {tgUnlinking ? 'Отвязываем…' : 'Да, отвязать'}
                </button>
                <button type="button" className="secondary" disabled={tgUnlinking} onClick={() => setTgUnlinkConfirm(false)}>
                  Назад
                </button>
              </div>
            )}
            {tgError && <div className="error" style={{ marginTop: 10 }}>{tgError}</div>}
          </div>
        )}
      </div>
      <div className="card">
        <h2>Сменить пароль</h2>
        <form onSubmit={onSubmit}>
          <div className="form-row">
            <label htmlFor="current">Текущий пароль</label>
            <input id="current" type="password" required value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} />
          </div>
          <div className="form-row">
            <label htmlFor="new">Новый пароль (мин. 10 символов)</label>
            <input id="new" type="password" required minLength={10} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          </div>
          {message && <div className={message.kind === 'ok' ? 'success' : 'error'}>{message.text}</div>}
          <button type="submit" disabled={submitting}>Сменить</button>
        </form>
      </div>
    </div>
  );
}
